<script>
  import Select from '@leaflink/stash/Select.vue';

  import { ROUTE_NAMES } from '@/constants';

  export default {
    name: 'VendorMenuBrandSelect',

    components: {
      Select,
    },

    inheritAttrs: false,

    props: {
      vendor: {
        type: Object,
        required: true,
      },

      showSellerLink: Boolean,
    },

    data() {
      return {
        ROUTE_NAMES,
      };
    },

    computed: {
      selectAttrs() {
        const attrs = { ...this.$attrs };

        delete attrs.class;

        return attrs;
      },
    },
  };
</script>

<template>
  <div class="flex flex-col" :class="$attrs.class">
    <Select
      single
      :label="$t('brand_menu.moreFromSeller')"
      :options="vendor.brands"
      :placeholder="vendor.placeholder"
      hide-search
      v-bind="selectAttrs"
    />
    <span v-if="showSellerLink" class="ll-mt-1 text-small">
      {{ $t('common.soldBy') }}
      <router-link
        :to="{
          name: vendor.company.enableVendorMenu ? ROUTE_NAMES.VENDOR_MENU : ROUTE_NAMES.SELLER_DETAILS,
          params: { sellerId: vendor.company.id },
        }"
      >
        <span> {{ vendor.company.name }}</span>
      </router-link>
    </span>
  </div>
</template>
